/* eslint-disable vue/no-v-html */
<template>
  <div class="intro-y grid grid-cols-12 gap-6 mt-8">
    <div class="col-span-12 mt-2 text-xl">
      <h2 class="font-medium truncate mt-3">
        {{
          residentSelected
            ? `Reporte General de ${residentSelected.full_name}`
            : 'Reporte general'
        }}
      </h2>
      <select
        v-model="residentSelected"
        class="mt-4 form-select box md:w-80"
        @change="changeResidentSelected"
      >
        <option
          v-for="resident in residents"
          :key="resident.id"
          :value="resident"
        >
          {{ resident.full_name }}
        </option>
      </select>
    </div>
    <template v-if="residentInformation">
      <div class="row-span-12 col-span-12 lg:col-span-6 mt-5 justify-center">
        <!-- <div class="col-span-12 mt-5 pl-5"> -->
        <div class="w-full flex flex-col">
          <div class="flex justify-center">
            <div class="mb-5 pl-5 lg:pb-3 cursor-pointer zoom-in">
              <img
                v-if="residentSelected.url"
                :src="residentSelected.url"
                alt="Resident Image"
                class="object-contain h-48 mb-5"
              />
              <img
                v-else
                src="@/assets/images/resident.png"
                alt="Resident Image"
                class="object-contain h-48 mb-5"
              />
              <input
                type="file"
                id="upload-file"
                name="upload-file"
                @change="onFileSelected"
                hidden
              />
              <label
                for="upload-file"
                refs="upload-file"
                class="btn btn-primary"
                >Subir Imagen</label
              >
            </div>
          </div>
        </div>
        <!-- </div> -->
        <div class="col-span-12 lg:col-span-6 mt-5 lg:ml-5 lg:pt-3">
          <h2 class="text-2xl font-medium truncate">
            Información del Residente
          </h2>
          <div class="Column col-md-4">
            <a
              class="flex items-center mr-3 text-green-600"
              href="javascript:;"
              @click="setEditResident()"
            >
              <CheckSquareIcon
                class="w-4 h-4 mr-1"
                style="{ background: '#5E5D5E' }"
              />
              Editar
            </a>
          </div>
          <div class="flex flex-col">
            <div class="text-xl mt-3">
              <span style="font-weight:bold;">Edad:</span>
              {{
                momentClass().diff(residentSelected.birth_date, 'years', false)
              }}
              años
            </div>
            <div class="text-xl mt-3">
              <span style="font-weight:bold;">Fecha de Nacimiento:</span>
              {{
                momentClass(residentSelected.birth_date).format('DD-MM-YYYY')
              }}
            </div>
            <div class="text-xl mt-3">
              <span style="font-weight:bold;">Fecha última valoración:</span>
              {{
                residentSelected.medical?.updated_at
                  ? momentClass(residentSelected.medical.updated_at).format(
                      'DD-MM-YYYY'
                    )
                  : ''
              }}
            </div>
            <div class="text-xl mt-3">
              <span style="font-weight:bold;">Residencia ubicación:</span>
              {{ residentSelected.house?.name }}
            </div>
            <div class="text-xl mt-3">
              <span style="font-weight:bold;">Especialista:</span>
              {{ residentSelected.specialist?.name }}
              {{ residentSelected.specialist?.last_name }}
            </div>
          </div>
        </div>
      </div>
      <div class="row-span-12 col-span-12 lg:col-span-6 mt-5">
        <div class="Column col-md-4">
          <h2 class="text-2xl font-medium truncate">Resumen Clínico</h2>
        </div>
        <div class="Column col-md-4">
          <a
            class="flex items-center mr-3 text-green-600"
            href="javascript:;"
            @click="setViewModalMedical()"
          >
            <CheckSquareIcon
              class="w-4 h-4 mr-1"
              style="{ background: '#5E5D5E' }"
            />
            Editar
          </a>
        </div>
        <template v-if="residentSelected.medical">
          <div class="text-xl mt-3">
            <span style="font-weight:bold;">Alergias:</span>
            {{ residentSelected.medical?.allergies }}
          </div>
          <div class="text-xl mt-3">
            <span style="font-weight:bold;">Antecedentes:</span>
            {{ residentSelected.medical?.historical }}
          </div>
          <div class="text-xl mt-3">
            <span style="font-weight:bold;">Social:</span>
            {{ residentSelected.medical?.social }}
          </div>
          <div class="text-xl mt-3">
            <span style="font-weight:bold;">Funcionalidad:</span>
            {{ residentSelected.medical?.funcionality }}
          </div>
          <div class="text-xl mt-3">
            <span style="font-weight:bold;">Sentidos:</span>
            {{ residentSelected.medical?.sense }}
          </div>
          <div class="text-xl mt-3">
            <span style="font-weight:bold;">Cognición:</span>
            {{ residentSelected.medical?.cognition }}
          </div>
          <div class="text-xl mt-3">
            <span style="font-weight:bold;">Ánimo:</span>
            {{ residentSelected.medical?.courage }}
          </div>
          <div class="text-xl mt-3">
            <span style="font-weight:bold;">Nutrición:</span>
            {{ residentSelected.medical?.nutrition }}
          </div>
          <div class="text-xl mt-3">
            <span style="font-weight:bold;">Labs:</span>
            {{ residentSelected.medical?.labs }}
          </div>
          <div class="text-xl mt-3">
            <span style="font-weight:bold;">Diagnóstico:</span>
            {{ residentSelected.medical?.diagnostic }}
          </div>
        </template>
      </div>
      <div class="col-span-12">
        <hr
          class="mx-auto"
          style="
                border: 2px solid #38a1f7;
              "
        />
        <!-- <Kardex v-if="meds" :medsInfo="meds" :results="residentInformation"/>
        <Kardex v-else :results="residentInformation" /> -->
        <h2 class="intro-y text-lg font-medium mt-10">KARDEX</h2>
        <div class="grid grid-cols-12 gap-6 mt-5">
          <div
            class="
              intro-y
              col-span-12
              flex flex-wrap
              sm:flex-nowrap
              items-center
              mt-2
            "
          >
            <div class="w-full sm:w-auto mt-3 sm:mt-0 sm:ml-auto md:ml-0">
              <div class="w-72 relative text-gray-700 dark:text-gray-300">
                <input
                  v-model="searchMeds"
                  type="text"
                  class="form-control w-72 box pr-10 placeholder-theme-13"
                  placeholder="Buscar"
                  @change="setFirstPageMeds"
                />
                <SearchIcon
                  class="w-4 h-4 absolute my-auto inset-y-0 mr-3 right-0"
                />
              </div>
            </div>
            <div class="hidden md:block mx-auto text-gray-600"></div>
            <button
              class="btn btn-success shadow-md mr-2 w-60 mt-5"
              @click="showModalCreateMeds"
            >
              Nuevo Medicamento +
            </button>
          </div>
          <!-- BEGIN: Data List -->
          <template v-if="residentSelected">
            <div class="intro-y col-span-12 overflow-auto lg:overflow-visible">
              <table
                class="table table-report -mt-2"
                aria-describedby="administrators table"
              >
                <thead>
                  <tr>
                    <th id="idH" class="whitespace-nowrap">#</th>
                    <th id="date2" class="text-center whitespace-nowrap">
                      Fecha
                    </th>
                    <th id="nombre" class="text-center whitespace-nowrap">
                      Medicamento
                    </th>
                    <th id="residencia" class="text-center whitespace-nowrap">
                      Presentacion
                    </th>
                    <th id="date1" class="text-center whitespace-nowrap">
                      Dosis
                    </th>
                    <th id="history" class="text-center whitespace-nowrap">
                      Horario
                    </th>
                    <th id="actionsH" class="text-center whitespace-nowrap">
                      Observaciones
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, index) in elementsMeds" :key="row.id">
                    <td class="w-20 font-medium">{{ index }}</td>
                    <td class="text-center w-10 font-medium">
                      {{
                        momentClass(row.prescribed_date).format('DD-MM-YYYY')
                      }}
                    </td>
                    <td class="text-center w-10 font-medium">
                      {{ row.med_name }}
                    </td>
                    <td class="text-center w-10 font-medium">
                      {{ row.presentation }}
                    </td>
                    <td class="text-center w-10 font-medium">
                      {{ row.dose }}
                    </td>
                    <td class="text-center w-10 font-medium">
                      {{ row.horario }}
                    </td>
                    <td class="text-center w-10 font-medium">
                      {{ row.observaciones }}
                    </td>
                    <td class="table-report__action w-56">
                      <div class="flex justify-center items-center">
                        <a
                          class="flex items-center mr-3 text-green-600"
                          href="javascript:;"
                          @click="setToEdit(row)"
                        >
                          <CheckSquareIcon class="w-4 h-4 mr-1" />
                          Editar
                        </a>
                        <a
                          href="javascript:;"
                          class="flex items-center text-red-700"
                          @click="setToDelete(row)"
                        >
                          <Trash2Icon class="w-4 h-4 mr-1" /> Eliminar
                        </a>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- END: Data List -->
            <!-- BEGIN: Pagination -->
            <div
              class="
                intro-y
                col-span-12
                flex flex-wrap
                sm:flex-row sm:flex-nowrap
                items-center
                py-10
              "
              v-if="pagesMeds > 1"
            >
              <ul class="pagination ml-auto" style="margin-right: revert;">
                <li @click="setFirstPageMeds" v-if="pageMeds !== 1">
                  <a class="pagination__link" href="javascript:;">
                    <ChevronsLeftIcon class="w-4 h-4" />
                  </a>
                </li>
                <li @click="changePageNegativeMeds" v-if="pageMeds !== 1">
                  <a class="pagination__link" href="javascript:;">
                    <ChevronLeftIcon class="w-4 h-4" />
                  </a>
                </li>
                <li
                  :key="elementMeds"
                  v-for="elementMeds in [
                    ...Array(maxShowButtonPagesMeds).keys()
                  ].map(
                    (dataElementMeds, index) =>
                      activeGroupMeds * maxShowButtonPagesMeds -
                      (maxShowButtonPagesMeds - index) +
                      1
                  )"
                >
                  <template v-if="elementMeds <= pagesMeds">
                    <a
                      class="pagination__link"
                      href="javascript:;"
                      @click="pageMeds = elementMeds"
                      :class="{
                        'pagination__link--active': elementMeds === pageMeds
                      }"
                      >{{ elementMeds }}
                    </a>
                  </template>
                </li>
                <li
                  v-if="pageMeds !== pagesMeds"
                  @click="changePagePositiveMeds"
                >
                  <a class="pagination__link" href="javascript:;">
                    <ChevronRightIcon class="w-4 h-4" />
                  </a>
                </li>
                <li @click="setlastPageMeds" v-if="pageMeds !== pagesMeds">
                  <a class="pagination__link" href="javascript:;">
                    <ChevronsRightIcon class="w-4 h-4" />
                  </a>
                </li>
              </ul>
            </div>
            <!-- END: Pagination -->
          </template>
        </div>
      </div>
      <div class="col-span-12 mb-5">
        <h2 class="text-2xl font-medium truncate mt-5 mb-2">Documentos</h2>
        <div class="grid grid-cols-12 gap-6 mt-5" v-if="residentSelected">
          <div
            class="
              intro-y
              col-span-12
              flex flex-wrap
              sm:flex-nowrap
              items-center
              mt-2
              ml-auto
            "
          >
            <div class="w-full sm:w-auto mt-3 sm:mt-0 sm:ml-auto md:ml-0">
              <div class="relative text-gray-700 dark:text-gray-300">
                <input
                  v-model="searchTwo"
                  type="text"
                  class="form-control w-72 box pr-10 placeholder-theme-13"
                  placeholder="Buscar"
                  @change="setFirstPageTwo"
                />
                <SearchIcon
                  class="w-4 h-4 absolute my-auto inset-y-0 mr-3 right-0"
                />
              </div>
            </div>
          </div>
          <!-- BEGIN: Data List -->
          <template v-if="docsData">
            <div class="intro-y col-span-12 overflow-auto lg:overflow-visible">
              <table
                class="table table-report -mt-2"
                aria-describedby="administrators table"
              >
                <thead>
                  <tr>
                    <th id="name" class="text-center whitespace-nowrap">
                      name
                    </th>
                    <th id="created" class="text-center whitespace-nowrap">
                      Creado
                    </th>
                    <th id="actionsH" class="text-center whitespace-nowrap">
                      Acciones
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr :key="row.id" v-for="row in elementsTwo">
                    <td class="text-center w-10 font-medium">
                      {{ row.name }}
                    </td>
                    <td class="text-center w-10 font-medium">
                      {{ row.created_at }}
                    </td>
                    <td class="table-report__action w-56">
                      <div class="flex justify-center items-center">
                        <div v-if="ios">
                          <a
                            v-if="row.url"
                            :href="row.url"
                            target="_blank"
                            width="300px"
                            height="400px"
                          >
                            <BookOpenIcon class="w-4 h-4 mr-1" /> Abrir
                          </a>
                        </div>
                        <div v-else>
                          <a
                            href="javascript:;"
                            class="flex items-center text-red-700"
                            @click="setVisualize(row)"
                          >
                            <BookOpenIcon class="w-4 h-4 mr-1" /> Abrir
                          </a>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- END: Data List -->
            <!-- BEGIN: Pagination -->
            <div
              class="
                intro-y
                col-span-12
                flex flex-wrap
                sm:flex-row sm:flex-nowrap
                items-center
                pb-10
              "
              v-if="pagesTwo > 1"
            >
              <ul class="pagination ml-auto" style="margin-right: revert;">
                <li @click="setFirstPageTwo" v-if="pageTwo !== 1">
                  <a class="pagination__link" href="javascript:;">
                    <ChevronsLeftIcon class="w-4 h-4" />
                  </a>
                </li>
                <li @click="changePageNegativeTwo" v-if="pageTwo !== 1">
                  <a class="pagination__link" href="javascript:;">
                    <ChevronLeftIcon class="w-4 h-4" />
                  </a>
                </li>
                <li
                  :key="elementTwo"
                  v-for="elementTwo in [
                    ...Array(maxShowButtonPagesTwo).keys()
                  ].map(
                    (dataElementTwo, index) =>
                      activeGroupTwo * maxShowButtonPagesTwo -
                      (maxShowButtonPagesTwo - index) +
                      1
                  )"
                >
                  <template v-if="elementTwo <= pagesTwo">
                    <a
                      class="pagination__link"
                      href="javascript:;"
                      @click="pageTwo = elementTwo"
                      :class="{
                        'pagination__link--active': elementTwo === pageTwo
                      }"
                      >{{ elementTwo }}
                    </a>
                  </template>
                </li>
                <li v-if="pageTwo !== pagesTwo" @click="changePagePositiveTwo">
                  <a class="pagination__link" href="javascript:;">
                    <ChevronRightIcon class="w-4 h-4" />
                  </a>
                </li>
                <li @click="setlastPageTwo" v-if="pageTwo !== pagesTwo">
                  <a class="pagination__link" href="javascript:;">
                    <ChevronsRightIcon class="w-4 h-4" />
                  </a>
                </li>
              </ul>
            </div>
            <!-- END: Pagination -->
          </template>
        </div>
        <hr
          class="mx-auto mt-5"
          style="
                border: 2px solid #38a1f7;
              "
        />
      </div>
      <div v-if="notas.length" class="col-span-12 lg:col-span-6 mt-5">
        <h2 class="text-2xl font-medium truncate">BITÁCORA PERSONAL</h2>
        <div
          v-for="(nota, key) in notas"
          :key="key"
          class="report-timeline mt-5 relative"
        >
          <div class="intro-x text-gray-500 text-xs text-center my-4">
            {{ nota.date }}
          </div>
          <div class="intro-x relative flex items-center mb-3">
            <div class="box px-5 py-3 ml-4 flex-1 zoom-in">
              <div class="text-gray-600 mt-1">
                <span v-html="nota.notas"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="med_notas.length" class="col-span-12 lg:col-span-6 mt-5">
        <h2 class="text-2xl font-medium truncate">PRESCRIPCIÓN MÉDICA</h2>
        <div
          v-for="(nota, key) in med_notas"
          :key="key"
          class="report-timeline mt-5 relative"
        >
          <div class="intro-x text-gray-500 text-xs text-center my-4">
            {{ nota.date }}
          </div>
          <div class="intro-x relative flex items-center mb-3">
            <div class="box px-5 py-3 ml-4 flex-1 zoom-in">
              <div class="text-gray-600 mt-1">
                <span v-html="nota.med_notas"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-span-12 mt-5 ml-2">
        <h2 class="text-2xl font-medium truncate">
          FRECUENCIA CARDIACA, PRESIÓN ARTERIAL DIASTÓLICA Y SISTÓLICA
        </h2>
      </div>
      <div class="col-span-12 lg:col-span-4 mt-5 ml-2">
        <div v-if="cardiacaAverage" class="intro-y box">
          <div
            :style="{ background: '#5E5D5E' }"
            class="
              flex flex-col
              border-b border-gray-200
              pb-3
              pr-3
              pl-2
              pt-1
              dark:border-dark-5
              font-medium
            "
          >
            <p class="text-2xl text-white">Frecuencia cardiaca promedio</p>
            <p class="text-4xl text-right text-white">
              {{ cardiacaAverage }}
            </p>
          </div>
        </div>
      </div>
      <div class="col-span-12 lg:col-span-4 mt-5 ml-2">
        <div v-if="diastolicaAverage" class="intro-y box">
          <div
            :style="{ background: '#F27100' }"
            class="
              flex flex-col
              border-b border-gray-200
              pb-3
              pr-3
              pl-2
              pt-1
              dark:border-dark-5
              font-medium
            "
          >
            <p class="text-2xl text-white">
              Presión diastólica “baja” promedio
            </p>
            <p class="text-4xl text-white text-right">
              {{ diastolicaAverage }}
            </p>
          </div>
        </div>
      </div>
      <div class="col-span-12 lg:col-span-4 mt-5 ml-2">
        <div v-if="sistolicaAverage" class="intro-y box">
          <div
            :style="{ background: '#00A1FF' }"
            class="
              flex flex-col
              border-b border-gray-200
              pb-3
              pr-3
              pl-2
              pt-1
              dark:border-dark-5
              font-medium
            "
          >
            <p class="text-2xl text-white">
              Presión sistólica “alta” promedio
            </p>
            <p class="text-4xl text-white text-right">
              {{ sistolicaAverage }}
            </p>
          </div>
        </div>
      </div>
      <div class="lg:col-start-3 lg:col-span-8 col-span-12 mt-5">
        <div class="intro-y box mt-5">
          <div class="p-5">
            <PresionesChart
              v-if="informationsFiltered.length"
              :height="200"
              :results="informationsFiltered"
            />
          </div>
        </div>
      </div>
      <div class="col-span-12 lg:col-span-6 mt-5">
        <h2 class="text-2xl font-medium truncate">OXIGENACIÓN</h2>
        <div v-if="oxigenacionAverage.result" class="intro-y box mt-5">
          <div
            :style="{ background: '#5E5E5E' }"
            class="
              flex flex-col
              border-b border-gray-200
              pb-3
              pr-3
              pl-2
              pt-1
              dark:border-dark-5
              font-medium
            "
          >
            <p class="text-2xl text-white">Oxigenación en sangre promedio</p>
            <p class="text-4xl text-white">{{ oxigenacionAverage.result }} %</p>
          </div>
          <div class="p-5">
            <OxigenacionChart :height="200" :results="informationsFiltered" />
          </div>
        </div>
      </div>
      <div v-if="glucosaAverage.result" class="col-span-12 lg:col-span-6 mt-5">
        <h2 class="text-2xl font-medium truncate">GLUCOSA</h2>
        <div class="intro-y box mt-5">
          <div
            :style="{ background: '#FDAE00' }"
            class="
              flex flex-col
              border-b border-gray-200
              pb-3
              pr-3
              pl-2
              pt-1
              dark:border-dark-5
              font-medium
            "
          >
            <p class="text-2xl text-white">Azúcar sangre promedio</p>
            <div class="flex text-4xl text-white">
              <div class="w-3/6">{{ glucosaAverage.result }}</div>
              <div class="w-3/6">{{ glucosaAverage.situation }}</div>
            </div>
          </div>
          <div class="p-5">
            <GlucosaChart :height="200" :results="glucosaAverage.results" />
          </div>
        </div>
      </div>
      <div v-if="pesoAverage.result" class="col-span-12 lg:col-span-6">
        <h2 class="text-2xl font-medium truncate">PESO</h2>
        <div class="intro-y box mt-5">
          <div
            :style="{ background: '#FDAE00' }"
            class="
              flex flex-col
              border-b border-gray-200
              pb-3
              pr-3
              pl-2
              pt-1
              dark:border-dark-5
              font-medium
            "
          >
            <p class="text-2xl text-white">Peso promedio</p>
            <div class="flex text-4xl text-white">
              <div class="w-full text-center">{{ pesoAverage.result }} KG</div>
            </div>
          </div>
          <div class="p-5">
            <PesoChart :height="200" :results="pesoAverage.results" />
          </div>
        </div>
      </div>
      <div v-if="temperaturaAverage.result" class="col-span-12 lg:col-span-6">
        <h2 class="text-2xl font-medium truncate">TEMPERATURA</h2>
        <div class="intro-y box mt-5">
          <div
            :style="{ background: '#FDAE00' }"
            class="
              flex flex-col
              border-b border-gray-200
              pb-3
              pr-3
              pl-2
              pt-1
              dark:border-dark-5
              font-medium
            "
          >
            <p class="text-2xl text-white">Temperatura promedio</p>
            <div class="flex text-4xl text-white">
              <div class="w-3/6">{{ temperaturaAverage.result }}</div>
              <div class="w-3/6">{{ temperaturaAverage.situation }}</div>
            </div>
          </div>
          <div class="p-5">
            <TemperaturaChart :height="200" :results="informationsFiltered" />
          </div>
        </div>
      </div>
      <div v-if="respiratoriaAverage.result" class="col-span-12 lg:col-span-6">
        <h2 class="text-2xl font-medium truncate">FRECUENCIA RESPIRATORIA</h2>
        <div class="intro-y box mt-5">
          <div
            :style="{ background: '#FDAE00' }"
            class="
              flex flex-col
              border-b border-gray-200
              pb-3
              pr-3
              pl-2
              pt-1
              dark:border-dark-5
              font-medium
            "
          >
            <p class="text-2xl text-white">Frecuencia respiratoria promedio</p>
            <div class="flex text-4xl text-white">
              <div class="w-3/6">{{ respiratoriaAverage.result }}</div>
              <div class="w-3/6">{{ respiratoriaAverage.situation }}</div>
            </div>
          </div>
          <div class="p-5">
            <RespiratoriaChart :height="200" :results="informationsFiltered" />
          </div>
        </div>
      </div>
      <div class="col-span-12 mt-5 ml-2">
        <h2 class="text-2xl font-medium truncate">ALIMENTACIÓN</h2>
      </div>
      <div class="col-span-12 lg:col-span-6">
        <div v-if="desayunoResults.length" class="intro-y box mt-5">
          <div
            :style="{ background: desayunoGeneralResult.background }"
            class="
              flex flex-col
              border-b border-gray-200
              pb-3
              pr-3
              pl-2
              pt-1
              dark:border-dark-5
              font-medium
            "
          >
            <p class="text-2xl text-white">
              {{ desayunoGeneralResult.plainText }}
            </p>
            <p class="text-5xl text-right text-white">
              {{ desayunoGeneralResult.result }}
            </p>
          </div>
          <div class="p-5">
            <AlimentationChart
              :height="200"
              :results="desayunoResults"
              :colors="colorsAlimentation"
            />
          </div>
        </div>
        <div v-if="cenaResults.length" class="intro-y box mt-5">
          <div
            :style="{ background: cenaGeneralResult.background }"
            class="
              flex flex-col
              border-b border-gray-200
              pb-3
              pr-3
              pl-2
              pt-1
              dark:border-dark-5
              font-medium
            "
          >
            <p class="text-2xl text-white">
              {{ cenaGeneralResult.plainText }}
            </p>
            <p class="text-5xl text-right text-white">
              {{ cenaGeneralResult.result }}
            </p>
          </div>
          <div class="p-5">
            <AlimentationChart
              :height="200"
              :results="cenaResults"
              :colors="colorsAlimentation"
            />
          </div>
        </div>
      </div>
      <div class="col-span-12 lg:col-span-6">
        <div v-if="comidaResults.length" class="intro-y box mt-5">
          <div
            :style="{ background: comidaGeneralResult.background }"
            class="
              flex flex-col
              border-b border-gray-200
              pb-3
              pr-3
              pl-2
              pt-1
              dark:border-dark-5
              font-medium
            "
          >
            <p class="text-2xl text-white">
              {{ comidaGeneralResult.plainText }}
            </p>
            <p class="text-5xl text-right text-white">
              {{ comidaGeneralResult.result }}
            </p>
          </div>
          <div class="p-5">
            <AlimentationChart
              :height="200"
              :results="comidaResults"
              :colors="colorsAlimentation"
            />
          </div>
        </div>
      </div>
    </template>
  </div>
  <!-- BEGIN: DOCUMENT MODAL -->
  <div ref="visualizeRow" class="modal">
    <div class="modal-dialog" width="800px">
      <div class="modal-content align-center" width="800px">
        <div v-if="rowSelectedTwo">
          <div v-if="$isMobile()">
            <embed
              class="ml-5 align-center"
              v-if="rowSelectedTwo.url"
              :src="rowSelectedTwo.url"
              type="application/pdf"
              width="300px"
              height="400px"
            />
          </div>
          <div v-else-if="tablet">
            <embed
              v-if="rowSelectedTwo.url"
              :src="rowSelectedTwo.url"
              type="application/pdf"
              width="400px"
              height="450px"
            />
          </div>
          <div v-else>
            <embed
              v-if="rowSelectedTwo.url"
              :src="rowSelectedTwo.url"
              type="application/pdf"
              width="800px"
              height="800px"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- END: DOCUMENT MODAL -->
  <!-- BEGIN: Modal Edit Row -->
  <div ref="rowMedical" class="modal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <!-- BEGIN: Modal Header -->
        <div class="modal-header">
          <h2 class="font-medium text-base mr-auto">Historial Clínico</h2>
          <a data-dismiss="modal" href="javascript:;">
            <XIcon class="w-5 h-5 text-gray-500" />
          </a>
        </div>
        <!-- END: Modal Header -->
        <!-- BEGIN: Modal Body -->
        <div class="modal-body grid grid-cols-12 gap-4 gap-y-3">
          <div class="col-span-12">
            <label class="form-label">Alergias</label>
            <textarea
              class="resize-none border rounded-md form-control h-24"
              v-model="medicalForm.allergies"
            >
            </textarea>
          </div>
          <div class="col-span-12 mt-2">
            <label class="form-label">Antecedentes</label>
            <textarea
              class="resize-none border rounded-md form-control h-24"
              v-model="medicalForm.historical"
            >
            </textarea>
          </div>
          <div class="col-span-12 mt-2">
            <label class="form-label">Social</label>
            <textarea
              class="resize-none border rounded-md form-control h-24"
              v-model="medicalForm.social"
            >
            </textarea>
          </div>
          <div class="col-span-12 mt-2">
            <label class="form-label">Funcionalidad</label>
            <textarea
              class="resize-none border rounded-md form-control h-24"
              v-model="medicalForm.funcionality"
            >
            </textarea>
          </div>
          <div class="col-span-12 mt-2">
            <label class="form-label">Sentidos</label>
            <textarea
              class="resize-none border rounded-md form-control h-24"
              v-model="medicalForm.sense"
            >
            </textarea>
          </div>
          <div class="col-span-12 mt-2">
            <label class="form-label">Cognición</label>
            <textarea
              class="resize-none border rounded-md form-control h-24"
              v-model="medicalForm.cognition"
            >
            </textarea>
          </div>
          <div class="col-span-12 mt-2">
            <label class="form-label">Ánimo</label>
            <textarea
              class="resize-none border rounded-md form-control h-24"
              v-model="medicalForm.courage"
            >
            </textarea>
          </div>
          <div class="col-span-12 mt-2">
            <label class="form-label">Nutrición</label>
            <textarea
              class="resize-none border rounded-md form-control h-24"
              v-model="medicalForm.nutrition"
            >
            </textarea>
          </div>
          <div class="col-span-12 mt-2">
            <label class="form-label">Labs</label>
            <textarea
              class="resize-none border rounded-md form-control h-24"
              v-model="medicalForm.labs"
            >
            </textarea>
          </div>
          <div class="col-span-12 mt-2">
            <label class="form-label">Diagnóstico</label>
            <textarea
              class="resize-none border rounded-md form-control h-24"
              v-model="medicalForm.diagnostic"
            >
            </textarea>
          </div>
        </div>
        <!-- END: Modal Body -->
        <!-- BEGIN: Modal Footer -->
        <div class="modal-footer text-right">
          <button
            type="button"
            data-dismiss="modal"
            class="btn btn-outline-secondary w-20 mr-1"
          >
            Cancelar
          </button>
          <button
            type="button"
            @click="editMedicalAction"
            class="btn btn-primary w-20"
          >
            Modificar
          </button>
        </div>
        <!-- END: Modal Footer -->
      </div>
    </div>
  </div>
  <!-- BEGIN: Modal Add Row MEDS-->
  <div ref="createRowMeds" class="modal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog">
      <form @submit.prevent="createActionMeds">
        <div class="modal-content">
          <!-- BEGIN: Modal Header -->
          <div class="modal-header">
            <h2 class="font-medium text-base mr-auto">Nuevo elemento</h2>
          </div>
          <!-- END: Modal Header -->
          <!-- BEGIN: Modal Body -->
          <div class="modal-body grid grid-cols-12 gap-4 gap-y-3">
            <div class="col-span-12 flex flex-col">
              <label class="form-label">Fecha de Ingreso</label>
              <div class="md:block lg:flex lg:w-1/3 md:w-full my-3">
                <div class="relative w-full mx-auto outline-none">
                  <div
                    class="
                      absolute
                      rounded-l
                      w-10
                      h-full
                      flex
                      items-center
                      justify-center
                      bg-gray-100
                      border
                      text-gray-600
                      dark:bg-dark-1 dark:border-dark-4
                      outline-none
                      focus:outline-none
                    "
                  >
                    <CalendarIcon class="w-4 h-4" />
                  </div>
                  <Litepicker
                    v-model="createFormMeds.prescribed_date"
                    readonly
                    :options="{
                      lang: 'es-MX',
                      autoApply: false,
                      startDate: '',
                      endDate: '',
                      format: 'YYYY-MM-DD',
                      singleMode: true,
                      numberOfColumns: 1,
                      numberOfMonths: 1,
                      showWeekNumbers: true,
                      dropdowns: {
                        minYear: 1900,
                        maxYear: null,
                        months: true,
                        years: true
                      }
                    }"
                    class="
                      form-control
                      w-72
                      block
                      ml-8
                      outline-none
                      focus:outline-none
                    "
                  />
                </div>
              </div>
              <template v-if="v$.createFormMeds.prescribed_date.$errors">
                <div
                  v-for="(error, index) in v$.createFormMeds.prescribed_date
                    .$errors"
                  :key="index"
                  class="text-red-700 mt-2"
                >
                  <strong v-if="error.$validator === 'required'"
                    >El campo es requerido</strong
                  >
                </div>
              </template>
            </div>
            <div class="col-span-12">
              <label class="form-label">Medicamento</label>
              <input
                v-model="createFormMeds.med_name"
                type="text"
                class="form-control"
                placeholder="Nombre Medicamento"
                required
              />
              <template v-if="v$.createFormMeds.med_name.$errors">
                <div
                  v-for="(error, index) in v$.createFormMeds.med_name.$errors"
                  :key="index"
                  class="text-red-700 mt-2"
                >
                  <strong v-if="error.$validator === 'required'"
                    >El campo es requerido</strong
                  >
                  <strong v-else-if="error.$validator === 'maxLength'"
                    >La longitud máxima es de 200 caracteres</strong
                  >
                </div>
              </template>
            </div>
            <div class="col-span-12">
              <label class="form-label">Presentación</label>
              <input
                v-model="createFormMeds.presentation"
                type="text"
                class="form-control"
                placeholder="Presentación"
              />
            </div>
            <div class="col-span-12">
              <label class="form-label">Dosis</label>
              <input
                v-model="createFormMeds.dose"
                type="text"
                class="form-control"
                placeholder="Dosis"
              />
            </div>
            <div class="col-span-12">
              <label class="form-label">Horario</label>
              <input
                v-model="createFormMeds.horario"
                type="text"
                class="form-control"
                placeholder="Horario"
              />
            </div>
            <div class="col-span-12">
              <label class="form-label">Observaciones</label>
              <input
                v-model="createFormMeds.observaciones"
                type="text"
                class="form-control"
                placeholder="Observaciones"
              />
            </div>
          </div>
          <!-- END: Modal Body -->
          <!-- BEGIN: Modal Footer -->
          <div class="modal-footer text-right">
            <button
              type="button"
              data-dismiss="modal"
              class="btn btn-outline-secondary w-20 mr-1"
            >
              Cancelar
            </button>
            <button
              type="submit"
              :disabled="v$.createFormMeds.$invalid"
              class="btn btn-primary w-20"
              :class="{ 'btn-danger': v$.createFormMeds.$invalid }"
            >
              Crear
            </button>
          </div>
          <!-- END: Modal Footer -->
        </div>
      </form>
    </div>
  </div>
  <!-- END: Modal Add Row -->
  <!-- BEGIN: Delete Confirmation Modal -->
  <div ref="deleteRow" class="modal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div v-if="rowSelected" class="modal-body p-0">
          <div class="p-5 text-center">
            <XCircleIcon class="w-16 h-16 text-red-700 mx-auto mt-3" />
            <div class="text-3xl mt-5">¿Estás seguro?</div>
            <div class="text-gray-600 mt-2">
              ¿Realmente quieres eliminar el registro
              <span style="font-weight: bold">{{ rowSelected.full_name }}</span
              >?
            </div>
          </div>
          <div class="px-5 pb-8 text-center">
            <button
              type="button"
              data-dismiss="modal"
              class="btn btn-outline-secondary w-24 mr-1"
            >
              Cancelar
            </button>
            <button
              type="button"
              class="btn btn-danger w-24"
              @click="deleteAction"
            >
              Eliminar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- END: Delete Confirmation Modal -->
  <!-- BEGIN: Modal Edit Row -->
  <div ref="editRowMeds" class="modal" tabindex="-1" aria-hidden="true">
    <div v-if="rowSelected" class="modal-dialog">
      <form @submit.prevent="editActionMeds">
        <div class="modal-content">
          <!-- BEGIN: Modal Header -->
          <div class="modal-header">
            <h2 class="font-medium text-base mr-auto">Modificar elemento</h2>
          </div>
          <!-- END: Modal Header -->
          <!-- BEGIN: Modal Body -->
          <div class="modal-body grid grid-cols-12 gap-4 gap-y-3">
            <div class="col-span-12 flex flex-col">
              <label class="form-label">Fecha de Ingreso</label>
              <div class="md:block lg:flex lg:w-1/3 md:w-full my-3">
                <div class="relative w-full mx-auto outline-none">
                  <div
                    class="
                      absolute
                      rounded-l
                      w-10
                      h-full
                      flex
                      items-center
                      justify-center
                      bg-gray-100
                      border
                      text-gray-600
                      dark:bg-dark-1 dark:border-dark-4
                      outline-none
                      focus:outline-none
                    "
                  >
                    <CalendarIcon class="w-4 h-4" />
                  </div>
                  <Litepicker
                    v-model="editFormMeds.prescribed_date"
                    readonly
                    :options="{
                      lang: 'es-MX',
                      autoApply: false,
                      startDate: '',
                      endDate: '',
                      format: 'YYYY-MM-DD',
                      singleMode: true,
                      numberOfColumns: 1,
                      numberOfMonths: 1,
                      showWeekNumbers: true,
                      dropdowns: {
                        minYear: 1900,
                        maxYear: null,
                        months: true,
                        years: true
                      }
                    }"
                    class="
                      form-control
                      w-72
                      block
                      ml-8
                      outline-none
                      focus:outline-none
                    "
                  />
                </div>
              </div>
              <template v-if="v$.editFormMeds.prescribed_date.$errors">
                <div
                  v-for="(error, index) in v$.editFormMeds.prescribed_date
                    .$errors"
                  :key="index"
                  class="text-red-700 mt-2"
                >
                  <strong v-if="error.$validator === 'required'"
                    >El campo es requerido</strong
                  >
                </div>
              </template>
            </div>
            <div class="col-span-12">
              <label class="form-label">Medicamento</label>
              <input
                v-model="editFormMeds.med_name"
                type="text"
                class="form-control"
                placeholder="Medicamento"
                required
              />
              <template v-if="v$.editFormMeds.med_name.$errors">
                <div
                  v-for="(error, index) in v$.editFormMeds.med_name.$errors"
                  :key="index"
                  class="text-red-700 mt-2"
                >
                  <strong v-if="error.$validator === 'required'"
                    >El campo es requerido</strong
                  >
                  <strong v-else-if="error.$validator === 'maxLength'"
                    >La longitud máxima es de 200 caracteres</strong
                  >
                </div>
              </template>
            </div>
            <div class="col-span-12">
              <label class="form-label">Presentación</label>
              <input
                v-model="editFormMeds.presentation"
                type="text"
                class="form-control"
                placeholder="Presentación"
              />
              <template v-if="v$.editFormMeds.presentation.$errors">
                <div
                  v-for="(error, index) in v$.editFormMeds.presentation.$errors"
                  :key="index"
                  class="text-red-700 mt-2"
                >
                  <strong v-if="error.$validator === 'required'"
                    >El campo es requerido</strong
                  >
                  <strong v-else-if="error.$validator === 'maxLength'"
                    >La longitud máxima es de 200 caracteres</strong
                  >
                </div>
              </template>
            </div>
            <div class="col-span-12">
              <label class="form-label">Dosis</label>
              <input
                v-model="editFormMeds.dose"
                type="text"
                class="form-control"
                placeholder="Dosis"
              />
              <template v-if="v$.editFormMeds.dose.$errors">
                <div
                  v-for="(error, index) in v$.editFormMeds.dose.$errors"
                  :key="index"
                  class="text-red-700 mt-2"
                >
                  <strong v-if="error.$validator === 'required'"
                    >El campo es requerido</strong
                  >
                  <strong v-else-if="error.$validator === 'maxLength'"
                    >La longitud máxima es de 200 caracteres</strong
                  >
                </div>
              </template>
            </div>
            <div class="col-span-12">
              <label class="form-label">Horario</label>
              <input
                v-model="editFormMeds.horario"
                type="text"
                class="form-control"
                placeholder="Horario"
              />
              <template v-if="v$.editFormMeds.horario.$errors">
                <div
                  v-for="(error, index) in v$.editFormMeds.horario.$errors"
                  :key="index"
                  class="text-red-700 mt-2"
                >
                  <strong v-if="error.$validator === 'required'"
                    >El campo es requerido</strong
                  >
                  <strong v-else-if="error.$validator === 'maxLength'"
                    >La longitud máxima es de 200 caracteres</strong
                  >
                </div>
              </template>
            </div>
            <div class="col-span-12">
              <label class="form-label">Observaciones</label>
              <input
                v-model="editFormMeds.observaciones"
                type="text"
                class="form-control"
                placeholder="Observaciones"
              />
              <template v-if="v$.editFormMeds.observaciones.$errors">
                <div
                  v-for="(error, index) in v$.editFormMeds.observaciones
                    .$errors"
                  :key="index"
                  class="text-red-700 mt-2"
                >
                  <strong v-if="error.$validator === 'required'"
                    >El campo es requerido</strong
                  >
                  <strong v-else-if="error.$validator === 'maxLength'"
                    >La longitud máxima es de 200 caracteres</strong
                  >
                </div>
              </template>
            </div>
          </div>
          <!-- END: Modal Body -->
          <!-- BEGIN: Modal Footer -->
          <div class="modal-footer text-right">
            <button
              type="button"
              data-dismiss="modal"
              class="btn btn-outline-secondary w-20 mr-1"
            >
              Cancelar
            </button>
            <button
              type="submit"
              :disabled="v$.editFormMeds.$invalid"
              class="btn btn-primary w-20"
              :class="{ 'btn-danger': v$.editFormMeds.$invalid }"
            >
              Modificar
            </button>
          </div>
          <!-- END: Modal Footer -->
        </div>
      </form>
    </div>
  </div>
  <!-- END: Modal Edit Row -->
  <!-- BEGIN: Modal Add Row -->
  <div ref="createRow" class="modal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog">
      <form @submit.prevent="createAction">
        <div class="modal-content">
          <!-- BEGIN: Modal Header -->
          <div class="modal-header">
            <h2 class="font-medium text-base mr-auto">
              Información Adicional del Kardex
            </h2>
          </div>
          <!-- END: Modal Header -->
          <!-- BEGIN: Modal Body -->
          <div class="modal-body grid grid-cols-12 gap-4 gap-y-3">
            <div class="col-span-12">
              <label class="form-label">Tipo</label>
              <select
                v-model="createForm.type"
                data-placeholder="Selecciona el tipo"
                class="w-full form-select mt-1"
                @change="changeKardexType"
                required
              >
                <option :value="'DAILY'">DIARIO</option>
                <option :value="'PRN'">PRN</option>
                <option :value="'CUSTOM'">CUSTOM</option>
              </select>
            </div>
            <div class="col-span-12 mt-2">
              <label class="form-label">Dosis</label>
              <input
                v-model="createForm.dose"
                type="text"
                class="form-control"
                placeholder="Dosis"
                required
              />
            </div>
            <template v-if="createForm.type === 'DAILY'">
              <div class="col-span-12 mt-4">
                <label class="form-label">Dosis Matutina</label>
                <input
                  v-model="createForm.morning_dose"
                  :disabled="createForm.morning_dose_prn"
                  type="number"
                  min="1"
                  class="form-control"
                  placeholder="Dosis Matutina"
                />
              </div>
              <div class="col-span-12 mt-2">
                <div class="form-check">
                  <input
                    id="checkbox-switch-morning-dose"
                    class="form-check-input"
                    type="checkbox"
                    @change="
                      createForm.morning_dose = createForm.morning_dose_prn
                        ? 'PRN'
                        : ''
                    "
                    v-model="createForm.morning_dose_prn"
                  />
                  <label
                    class="form-check-label"
                    for="checkbox-switch-morning-dose"
                    >Marcar como PRN
                  </label>
                </div>
              </div>
              <div class="col-span-12 mt-2">
                <label class="form-label"
                  >Hora de la dosis matutina (Opcional)</label
                >
                <input
                  v-model="createForm.morning_dose_hour"
                  type="time"
                  class="form-control"
                  @keydown="$event.preventDefault()"
                />
              </div>
              <div class="col-span-12 mt-4">
                <label class="form-label">Dosis Vespertina</label>
                <input
                  v-model="createForm.afternoon_dose"
                  :disabled="createForm.afternoon_dose_prn"
                  type="number"
                  min="1"
                  class="form-control"
                  placeholder="Dosis Vespertina"
                />
              </div>
              <div class="col-span-12 mt-2">
                <div class="form-check">
                  <input
                    id="checkbox-switch-afternoon-dose"
                    class="form-check-input"
                    type="checkbox"
                    @change="
                      createForm.afternoon_dose = createForm.afternoon_dose_prn
                        ? 'PRN'
                        : ''
                    "
                    v-model="createForm.afternoon_dose_prn"
                  />
                  <label
                    class="form-check-label"
                    for="checkbox-switch-afternoon-dose"
                    >Marcar como PRN
                  </label>
                </div>
              </div>
              <div class="col-span-12 mt-2">
                <label class="form-label"
                  >Hora de la dosis vespertina (Opcional)</label
                >
                <input
                  v-model="createForm.afternoon_dose_hour"
                  type="time"
                  class="form-control"
                  @keydown="$event.preventDefault()"
                />
              </div>
              <div class="col-span-12 mt-4">
                <label class="form-label">Dosis Nocturna</label>
                <input
                  v-model="createForm.night_dose"
                  :disabled="createForm.night_dose_prn"
                  type="number"
                  min="1"
                  class="form-control"
                  placeholder="Dosis Nocturna"
                />
              </div>
              <div class="col-span-12 mt-2">
                <div class="form-check">
                  <input
                    id="checkbox-switch-night-dose"
                    class="form-check-input"
                    type="checkbox"
                    @change="
                      createForm.night_dose = createForm.night_dose_prn
                        ? 'PRN'
                        : ''
                    "
                    v-model="createForm.night_dose_prn"
                  />
                  <label
                    class="form-check-label"
                    for="checkbox-switch-night-dose"
                    >Marcar como PRN
                  </label>
                </div>
              </div>
              <div class="col-span-12 mt-2">
                <label class="form-label"
                  >Hora de la dosis nocturna (Opcional)</label
                >
                <input
                  v-model="createForm.night_dose_hour"
                  type="time"
                  class="form-control"
                  @keydown="$event.preventDefault()"
                />
              </div>
            </template>
            <template v-if="createForm.type === 'CUSTOM'">
              <div class="col-span-12 mt-4">
                <label class="form-label">Dosis personalizada</label>
                <textarea
                  class="resize-none border rounded-md form-control h-24"
                  v-model="createForm.custom_dose"
                >
                </textarea>
              </div>
            </template>
          </div>
          <!-- END: Modal Body -->
          <!-- BEGIN: Modal Footer -->
          <div class="modal-footer flex flex-row justify-evenly">
            <button
              type="button"
              data-dismiss="modal"
              class="btn btn-outline-secondary px-5"
            >
              Cancelar
            </button>
            <button
              :disabled="!!!createForm.type || !!!createForm.dose"
              type="submit"
              class="btn btn-primary px-2"
            >
              Guardar cambios
            </button>
          </div>
          <!-- END: Modal Footer -->
        </div>
      </form>
    </div>
  </div>
  <!-- END: Modal Add Row -->
  <!-- BEGIN: Modal Edit Row -->
  <div ref="editRow" class="modal" tabindex="-1" aria-hidden="true">
    <div v-if="rowSelected" class="modal-dialog">
      <form @submit.prevent="editAction">
        <div class="modal-content">
          <!-- BEGIN: Modal Header -->
          <div class="modal-header">
            <h2 class="font-medium text-base mr-auto">Modificar elemento</h2>
          </div>
          <!-- END: Modal Header -->
          <!-- BEGIN: Modal Body -->
          <div class="modal-body grid grid-cols-12 gap-4 gap-y-3">
            <div class="col-span-12">
              <label class="form-label">Nombre Completo</label>
              <input
                v-model="editForm.fullName"
                type="text"
                class="form-control"
                placeholder="Nombre Completo"
                required
              />
              <template v-if="v$.editForm.fullName.$errors">
                <div
                  v-for="(error, index) in v$.editForm.fullName.$errors"
                  :key="index"
                  class="text-red-700 mt-2"
                >
                  <strong v-if="error.$validator === 'required'"
                    >El campo es requerido</strong
                  >
                  <strong v-else-if="error.$validator === 'maxLength'"
                    >La longitud máxima es de 200 caracteres</strong
                  >
                </div>
              </template>
            </div>
            <div class="col-span-12 flex flex-col">
              <label class="form-label">Fecha de Ingreso</label>
              <div class="md:block lg:flex lg:w-1/3 md:w-full my-3">
                <div class="relative w-full mx-auto outline-none">
                  <div
                    class="
                        absolute
                        rounded-l
                        w-10
                        h-full
                        flex
                        items-center
                        justify-center
                        bg-gray-100
                        border
                        text-gray-600
                        dark:bg-dark-1 dark:border-dark-4
                        outline-none
                        focus:outline-none
                      "
                  >
                    <CalendarIcon class="w-4 h-4" />
                  </div>
                  <Litepicker
                    v-model="editForm.dateEntry"
                    readonly
                    :options="{
                      lang: 'es-MX',
                      autoApply: false,
                      startDate: '',
                      endDate: '',
                      format: 'YYYY-MM-DD',
                      singleMode: true,
                      numberOfColumns: 1,
                      numberOfMonths: 1,
                      showWeekNumbers: true,
                      dropdowns: {
                        minYear: 1900,
                        maxYear: null,
                        months: true,
                        years: true
                      }
                    }"
                    class="
                        form-control
                        w-72
                        block
                        ml-8
                        outline-none
                        focus:outline-none
                      "
                  />
                </div>
              </div>
              <template v-if="v$.editForm.dateEntry.$errors">
                <div
                  v-for="(error, index) in v$.editForm.dateEntry.$errors"
                  :key="index"
                  class="text-red-700 mt-2"
                >
                  <strong v-if="error.$validator === 'required'"
                    >El campo es requerido</strong
                  >
                </div>
              </template>
            </div>
            <div class="col-span-12 flex flex-col">
              <label class="form-label">Fecha de nacimiento</label>
              <div class="md:block lg:flex lg:w-1/3 md:w-full my-3">
                <div class="relative w-full mx-auto outline-none">
                  <div
                    class="
                        absolute
                        rounded-l
                        w-10
                        h-full
                        flex
                        items-center
                        justify-center
                        bg-gray-100
                        border
                        text-gray-600
                        dark:bg-dark-1 dark:border-dark-4
                        outline-none
                        focus:outline-none
                      "
                  >
                    <CalendarIcon class="w-4 h-4" />
                  </div>
                  <Litepicker
                    v-model="editForm.birthDate"
                    readonly
                    :options="{
                      lang: 'es-MX',
                      autoApply: false,
                      startDate: '',
                      endDate: '',
                      format: 'YYYY-MM-DD',
                      singleMode: true,
                      numberOfColumns: 1,
                      numberOfMonths: 1,
                      showWeekNumbers: true,
                      dropdowns: {
                        minYear: 1900,
                        maxYear: null,
                        months: true,
                        years: true
                      }
                    }"
                    class="
                        form-control
                        w-72
                        block
                        ml-8
                        outline-none
                        focus:outline-none
                      "
                  />
                </div>
              </div>
              <template v-if="v$.editForm.birthDate.$errors">
                <div
                  v-for="(error, index) in v$.editForm.birthDate.$errors"
                  :key="index"
                  class="text-red-700 mt-2"
                >
                  <strong v-if="error.$validator === 'required'"
                    >El campo es requerido</strong
                  >
                </div>
              </template>
            </div>
            <div class="col-span-12">
              <label class="form-label">Residencia</label>
              <select
                v-model="editForm.houseId"
                data-placeholder="Selecciona la residencia"
                class="w-full form-select mt-1"
                required
              >
                <option v-for="item in houses" :key="item.id" :value="item.id">
                  {{ item.name }}
                </option>
              </select>
              <template v-if="v$.editForm.houseId.$errors">
                <div
                  v-for="(error, index) in v$.editForm.houseId.$errors"
                  :key="index"
                  class="text-red-700 mt-2"
                >
                  <strong v-if="error.$validator === 'required'"
                    >El campo es requerido</strong
                  >
                  <strong v-else-if="error.$validator === 'integer'"
                    >El campo deber ser entero</strong
                  >
                </div>
              </template>
            </div>
            <div class="col-span-12">
              <label class="form-label">Especialista</label>
              <select
                v-model="editForm.specialistId"
                data-placeholder="Selecciona el especialista"
                class="w-full form-select mt-1"
              >
                <option :value="''">Sin asignar</option>
                <option
                  v-for="item in specialists"
                  :key="item.id"
                  :value="item.id"
                >
                  {{ item.name }} {{ item.last_name }}
                </option>
              </select>
              <template v-if="v$.editForm.specialistId.$errors">
                <div
                  v-for="(error, index) in v$.editForm.specialistId.$errors"
                  :key="index"
                  class="text-red-700 mt-2"
                >
                  <strong v-if="error.$validator === 'integer'"
                    >El campo deber ser entero</strong
                  >
                </div>
              </template>
            </div>
          </div>
          <!-- END: Modal Body -->
          <!-- BEGIN: Modal Footer -->
          <div class="modal-footer text-right">
            <button
              type="button"
              data-dismiss="modal"
              class="btn btn-outline-secondary w-20 mr-1"
            >
              Cancelar
            </button>
            <button
              type="submit"
              :disabled="v$.editForm.$invalid"
              class="btn btn-primary w-20"
              :class="{ 'btn-danger': v$.editForm.$invalid }"
            >
              Modificar
            </button>
          </div>
          <!-- END: Modal Footer -->
        </div>
      </form>
    </div>
  </div>
  <!-- END: Modal Edit Row -->
  <div class="button-bar">
    <div v-if="$isMobile()">
      <link
        rel="stylesheet"
        href="https://maxcdn.bootstrapcdn.com/font-awesome/4.5.0/css/font-awesome.min.css"
      />
      <a
        href="http://api.whatsapp.com/send?phone=525543903142&text=Hola%21%20Quisiera%20m%C3%A1s%20informaci%C3%B3n%20sobre%20Asistomedia%20Gracias."
        class="floatMobile"
        target="_blank"
      >
        <i class="fa fa-whatsapp my-float-mob"></i>
      </a>
    </div>
    <div v-else>
      <link
        rel="stylesheet"
        href="https://maxcdn.bootstrapcdn.com/font-awesome/4.5.0/css/font-awesome.min.css"
      />
      <a
        href="http://api.whatsapp.com/send?phone=525543903142&text=Hola%21%20Quisiera%20m%C3%A1s%20informaci%C3%B3n%20sobre%20Asistomedia%20Gracias."
        class="float"
        target="_blank"
      >
        <i class="fa fa-whatsapp my-float"></i>
      </a>
    </div>
  </div>
</template>

<script>
import { cleanSession, getFirstErrorMessage } from '../../utils/tools'
import AlimentationChart from '@/components/alimentation-chart/Main.vue'
import OxigenacionChart from '@/components/oxigenacion-chart/Main.vue'
import GlucosaChart from '@/components/glucosa-chart/Main.vue'
import PesoChart from '@/components/peso-chart/Main.vue'
import TemperaturaChart from '@/components/temperatura-chart/Main.vue'
import RespiratoriaChart from '@/components/respiratoria-chart/Main.vue'
import PresionesChart from '@/components/presiones-chart/Main.vue'
import moment from 'moment-timezone'
import { maxLength, required, integer } from '@vuelidate/validators'
import useVuelidate from '@vuelidate/core'
import { isTablet, isAndroid } from 'mobile-device-detect'
export default {
  components: {
    AlimentationChart,
    OxigenacionChart,
    GlucosaChart,
    TemperaturaChart,
    RespiratoriaChart,
    PresionesChart,
    PesoChart
  },
  setup() {
    return { v$: useVuelidate() }
  },
  data() {
    return {
      momentClass: moment,
      residents: undefined,
      residentSelected: undefined,
      docsData: [],
      NotasIDs: [],
      medNotasIDs: [],
      docuInfo: undefined,
      residentInformation: undefined,
      medicines: undefined,
      meds: undefined,
      kardex: false,
      eliminate: false,
      isHidden: false,
      selectedFile: null,
      search: '',
      elementsByPage: 3,
      maxShowButtonPages: 3,
      page: 1,
      activeGroup: 1,
      searchTwo: '',
      elementsByPageTwo: 3,
      maxShowButtonPagesTwo: 3,
      pageTwo: 1,
      activeGroupTwo: 1,
      searchThree: '',
      elementsByPageThree: 3,
      maxShowButtonPagesThree: 3,
      pageThree: 1,
      activeGroupThree: 1,
      searchFour: '',
      elementsByPageFour: 8,
      maxShowButtonPagesFour: 3,
      pageFour: 1,
      activeGroupFour: 1,
      searchMeds: '',
      elementsByPageMeds: 8,
      maxShowButtonPagesMeds: 3,
      pageMeds: 1,
      activeGroupMeds: 1,
      medList: [],
      rowSelected: undefined,
      rowSelectedTwo: undefined,
      houses: undefined,
      specialists: undefined,
      tablet: isTablet,
      ios: isAndroid,
      createForm: {
        resident_id: undefined,
        medicine_id: undefined,
        type: undefined,
        dose: undefined
      },
      createFormMeds: {
        resident_id: undefined,
        med_name: '',
        dose: '',
        presentation: '',
        observaciones: '',
        horario: '',
        prescribed_date: ''
      },
      editFormMeds: {
        med_name: '',
        dose: '',
        presentation: '',
        observaciones: '',
        horario: '',
        prescribed_date: ''
      },
      dateForm: {
        daterange: ''
      },
      editForm: {
        fullName: '',
        dateEntry: '',
        birthDate: '',
        specialistId: '',
        houseId: ''
      },
      generalTextAlimentation: [
        'Buena Alimentación',
        'Alimentación Regular',
        'Mala Alimentación'
      ],
      colorsAlimentation: ['#1EB000', '#FFD933', '#FF644E'],
      medicalForm: {}
    }
  },
  validations() {
    return {
      editForm: {
        fullName: { required, $autoDirty: true, maxLength: maxLength(200) },
        dateEntry: { required, $autoDirty: true },
        birthDate: { required, $autoDirty: true },
        houseId: { required, $autoDirty: true, integer },
        specialistId: { $autoDirty: true, integer }
      },
      editFormMeds: {
        med_name: { required, $autoDirty: true, maxLength: maxLength(200) },
        dose: { $autoDirty: true },
        presentation: { $autoDirty: true },
        observaciones: { $autoDirty: true },
        horario: { $autoDirty: true },
        prescribed_date: { $autoDirty: true }
      },
      createFormMeds: {
        med_name: { required, $autoDirty: true, maxLength: maxLength(200) },
        prescribed_date: { required, $autoDirty: true }
      }
    }
  },
  validationConfig: {
    $lazy: false
  },
  computed: {
    informationsFiltered() {
      if (this.residentInformation) {
        const tableheaders = []
        for (let i = 0; i < this.residentInformation.length; i++) {
          const test = this.residentInformation[i].cardiaca
          if (test !== null) {
            tableheaders.push(this.residentInformation[i])
          }
          if (tableheaders.length >= 30) {
            break
          }
        }
        return tableheaders.reverse()
      }
      return []
    },
    desayunoResults: function() {
      const results = []
      if (this.residentInformation) {
        const filterResults = this.residentInformation
          .map(information => information.desayuno)
          .filter(alimentation => alimentation)
        if (filterResults.length) {
          results.push(
            (filterResults.filter(result => Number(result) === 3).length /
              filterResults.length) *
              100
          )
          results.push(
            (filterResults.filter(result => Number(result) === 2).length /
              filterResults.length) *
              100
          )
          results.push(
            (filterResults.filter(result => Number(result) === 1).length /
              filterResults.length) *
              100
          )
        }
      }
      return results
    },
    desayunoGeneralResult: function() {
      if (this.desayunoResults.length === 3) {
        const highIndex = this.indexOfMax(this.desayunoResults)
        return {
          plainText: `${this.generalTextAlimentation[highIndex]} en el desayuno`,
          background: this.colorsAlimentation[highIndex],
          result: `${this.desayunoResults[highIndex].toFixed(2)} %`
        }
      }
      return {}
    },
    comidaResults: function() {
      const results = []
      if (this.residentInformation) {
        const filterResults = this.residentInformation
          .map(information => information.comida)
          .filter(alimentation => alimentation)
        if (filterResults.length) {
          results.push(
            (filterResults.filter(result => Number(result) === 3).length /
              filterResults.length) *
              100
          )
          results.push(
            (filterResults.filter(result => Number(result) === 2).length /
              filterResults.length) *
              100
          )
          results.push(
            (filterResults.filter(result => Number(result) === 1).length /
              filterResults.length) *
              100
          )
        }
      }
      return results
    },
    comidaGeneralResult: function() {
      if (this.comidaResults.length === 3) {
        const highIndex = this.indexOfMax(this.comidaResults)
        return {
          plainText: `${this.generalTextAlimentation[highIndex]} en la comida`,
          background: this.colorsAlimentation[highIndex],
          result: `${this.comidaResults[highIndex].toFixed(2)} %`
        }
      }
      return {}
    },
    cenaResults: function() {
      const results = []
      if (this.residentInformation) {
        const filterResults = this.residentInformation
          .map(information => information.cena)
          .filter(alimentation => alimentation)
        if (filterResults.length) {
          results.push(
            (filterResults.filter(result => Number(result) === 3).length /
              filterResults.length) *
              100
          )
          results.push(
            (filterResults.filter(result => Number(result) === 2).length /
              filterResults.length) *
              100
          )
          results.push(
            (filterResults.filter(result => Number(result) === 1).length /
              filterResults.length) *
              100
          )
        }
      }
      return results
    },
    cenaGeneralResult: function() {
      if (this.cenaResults.length === 3) {
        const highIndex = this.indexOfMax(this.cenaResults)
        return {
          plainText: `${this.generalTextAlimentation[highIndex]} en la cena`,
          background: this.colorsAlimentation[highIndex],
          result: `${this.cenaResults[highIndex].toFixed(2)} %`
        }
      }
      return {}
    },
    oxigenacionAverage: function() {
      const results = {
        result: 0,
        byDate: true
      }
      if (this.informationsFiltered.length) {
        const filterResults = this.informationsFiltered
          .map(information => Number(information.oxigeno) || 0)
          .filter(data => data)
        if (filterResults.length) {
          results.result = (
            filterResults.reduce((a, b) => a + b, 0) / filterResults.length || 0
          ).toFixed(2)
        }
      }
      return results
    },
    glucosaAverage: function() {
      const response = {
        result: 0,
        situation: '',
        byDate: true,
        results: []
      }
      const glucosaResults = []
      for (let i = 0; i < this.residentInformation.length; i++) {
        const test = this.residentInformation[i].glucosa
        if (test !== null) {
          glucosaResults.push(this.residentInformation[i])
        }
        if (glucosaResults.length >= 30) {
          break
        }
      }
      if (glucosaResults.length) {
        response.results = glucosaResults.reverse()
        const filterResults = glucosaResults
          .map(information => Number(information.glucosa) || 0)
          .filter(data => data)
        if (filterResults.length) {
          const result = (
            filterResults.reduce((a, b) => a + b, 0) / filterResults.length || 0
          ).toFixed(2)
          response.result = result
          switch (true) {
            case result <= 70:
              response.situation = 'Baja'
              break
            case result <= 100:
              response.situation = 'Normal'
              break
            default:
              response.situation = 'Alta'
              break
          }
        }
      }
      return response
    },
    pesoAverage: function() {
      const response = {
        result: 0,
        byDate: true,
        results: []
      }
      const pesoResults = []
      for (let i = 0; i < this.residentInformation.length; i++) {
        const test = this.residentInformation[i].peso
        if (test !== null) {
          pesoResults.push(this.residentInformation[i])
        }
        if (pesoResults.length >= 30) {
          break
        }
      }
      if (pesoResults.length) {
        response.results = pesoResults.reverse()
        const filterResults = pesoResults
          .map(information => Number(information.peso) || 0)
          .filter(data => data)
        if (filterResults.length) {
          const result = (
            filterResults.reduce((a, b) => a + b, 0) / filterResults.length || 0
          ).toFixed(2)
          response.result = result
        }
      }
      return response
    },
    temperaturaAverage: function() {
      const response = {
        result: 0,
        situation: '',
        byDate: true
      }
      if (this.informationsFiltered.length) {
        const filterResults = this.informationsFiltered
          .map(information => Number(information.temperatura) || 0)
          .filter(data => data)
        if (filterResults.length) {
          const result = (
            filterResults.reduce((a, b) => a + b, 0) / filterResults.length || 0
          ).toFixed(2)
          response.result = result
          switch (true) {
            case result < 36:
              response.situation = 'Baja'
              break
            case result < 37:
              response.situation = 'Normal'
              break
            default:
              response.situation = 'Alta'
              break
          }
        }
      }
      return response
    },
    respiratoriaAverage: function() {
      const response = {
        result: 0,
        situation: '',
        byDate: true
      }
      if (this.informationsFiltered.length) {
        const filterResults = this.informationsFiltered
          .map(information => Number(information.respiratoria) || 0)
          .filter(data => data)
        if (filterResults.length) {
          const result = (
            filterResults.reduce((a, b) => a + b, 0) / filterResults.length || 0
          ).toFixed(2)
          response.result = result
          switch (true) {
            case result <= 12:
              response.situation = 'Baja'
              break
            case result < 18:
              response.situation = 'Normal'
              break
            default:
              response.situation = 'Alta'
              break
          }
        }
      }
      return response
    },
    cardiacaAverage: function() {
      const result = 0
      if (this.informationsFiltered.length) {
        const filterResults = this.informationsFiltered
          .map(information => Number(information.cardiaca) || 0)
          .filter(data => data)
        if (filterResults.length) {
          return (
            filterResults.reduce((a, b) => a + b, 0) / filterResults.length || 0
          ).toFixed(2)
        }
      }
      return result
    },
    diastolicaAverage: function() {
      const result = 0
      if (this.informationsFiltered.length) {
        const filterResults = this.informationsFiltered
          .map(information => Number(information.diastolica) || 0)
          .filter(data => data)
        if (filterResults.length) {
          return (
            filterResults.reduce((a, b) => a + b, 0) / filterResults.length || 0
          ).toFixed(2)
        }
      }
      return result
    },
    sistolicaAverage: function() {
      const result = 0
      if (this.informationsFiltered.length) {
        const filterResults = this.informationsFiltered
          .map(information => Number(information.sistolica) || 0)
          .filter(data => data)
        if (filterResults.length) {
          return (
            filterResults.reduce((a, b) => a + b, 0) / filterResults.length || 0
          ).toFixed(2)
        }
      }
      return result
    },
    notas: function() {
      const result = []
      if (this.NotasIDs) {
        const filterResults = this.NotasIDs.map(information => ({
          notas: information.notas,
          date: moment.utc(information.day).format('DD-MM-YYYY')
        })).filter(data => data.notas)
        if (filterResults.length) {
          return filterResults.reverse()
        }
      }
      return result
    },
    med_notas: function() {
      const result = []
      if (this.medNotasIDs) {
        const filterResults = this.medNotasIDs
          .map(information => ({
            med_notas: information.med_notas,
            date: moment.utc(information.day).format('DD-MM-YYYY')
          }))
          .filter(data => data.med_notas)
        if (filterResults.length) {
          return filterResults.reverse()
        }
      }
      return result
    },
    med_notas2: function() {
      const result = []
      if (this.residentInformation) {
        const filterResults = this.residentInformation
          .map(information => ({
            med_notas: information.med_notas,
            date: moment.utc(information.day).format('DD-MM-YYYY')
          }))
          .filter(data => data.med_notas)
        if (filterResults.length) {
          return filterResults.reverse()
        }
      }
      return result
    },
    filteredElementsDocs() {
      if (this.docsData) {
        let elementsTwo = this.docsData
        if (this.searchTwo && this.searchTwo.length) {
          elementsTwo = elementsTwo.filter(
            row =>
              row.url
                .toUpperCase()
                .includes(this.searchTwo.trim().toUpperCase()) ||
              row.name
                .toUpperCase()
                .includes(this.searchTwo.trim().toUpperCase())
          )
        }
        return elementsTwo
      }
      return []
    },
    elementsTwo: function() {
      if (this.filteredElementsDocs) {
        const takeElements =
          this.elementsByPageTwo * this.pageTwo -
            this.filteredElementsDocs.length <
          0
            ? this.elementsByPageTwo * this.pageTwo
            : this.filteredElementsDocs.length
        return this.filteredElementsDocs.slice(
          this.elementsByPageTwo * this.pageTwo - this.elementsByPageTwo,
          takeElements
        )
      }
      return []
    },
    pagesTwo: function() {
      return this.filteredElementsDocs
        ? Math.ceil(this.filteredElementsDocs.length / this.elementsByPageTwo)
        : 1
    },
    totalGroupsTwo: function() {
      return Math.ceil(this.pagesTwo / this.maxShowButtonPagesTwo)
    },
    filteredElementsKardex() {
      if (this.residentSelected.kardexes) {
        let elementsFour = this.residentSelected.kardexes
        if (this.searchFour && this.searchFour.length) {
          elementsFour = elementsFour.filter(
            kardex =>
              kardex.url
                .toUpperCase()
                .includes(this.searchFour.trim().toUpperCase()) ||
              kardex.name
                .toUpperCase()
                .includes(this.searchFour.trim().toUpperCase())
          )
        }
        return elementsFour
      }
      return []
    },
    elementsFour: function() {
      if (this.filteredElementsKardex) {
        const takeElements =
          this.elementsByPageFour * this.pageFour -
            this.filteredElementsKardex.length <
          0
            ? this.elementsByPageFour * this.pageFour
            : this.filteredElementsKardex.length
        return this.filteredElementsKardex.slice(
          this.elementsByPageFour * this.pageFour - this.elementsByPageFour,
          takeElements
        )
      }
      return []
    },
    pagesFour: function() {
      return this.filteredElementsKardex
        ? Math.ceil(
            this.filteredElementsKardex.length / this.elementsByPageFour
          )
        : 1
    },
    totalGroupsFour: function() {
      return Math.ceil(this.pagesFour / this.maxShowButtonPagesFour)
    },
    filteredElementsMeds() {
      if (this.residentSelected) {
        let elementsMeds = this.meds
        if (this.searchMeds && this.searchMeds.length) {
          elementsMeds = elementsMeds.filter(row =>
            row.med_name
              .toUpperCase()
              .includes(this.searchMeds.trim().toUpperCase())
          )
        }
        return elementsMeds
      }
      return []
    },
    elementsMeds: function() {
      if (this.filteredElementsMeds) {
        const takeElementsMeds =
          this.elementsByPageMeds * this.pageMeds -
            this.filteredElementsMeds.length <
          0
            ? this.elementsByPageMeds * this.pageMeds
            : this.filteredElementsMeds.length
        return this.filteredElementsMeds.slice(
          this.elementsByPageMeds * this.pageMeds - this.elementsByPageMeds,
          takeElementsMeds
        )
      }
      return []
    },
    pagesMeds: function() {
      return this.filteredElementsMeds
        ? Math.ceil(this.filteredElementsMeds.length / this.elementsByPageMeds)
        : 1
    },
    totalGroupsMeds: function() {
      return Math.ceil(this.pagesMeds / this.maxShowButtonPagesMeds)
    },
    filteredElements() {
      if (this.medicines) {
        let elements = this.medicines
        if (this.search && this.search.length) {
          elements = elements.filter(
            row =>
              row.name
                .toUpperCase()
                .includes(this.search.trim().toUpperCase()) ||
              row.key_name
                .toUpperCase()
                .includes(this.search.trim().toUpperCase()) ||
              row.provider
                .toUpperCase()
                .includes(this.search.trim().toUpperCase()) ||
              row.price.toString().includes(this.search.trim()) ||
              row.sale_price.toString().includes(this.search.trim())
          )
        }
        return elements
      }
      return []
    },
    elements: function() {
      if (this.filteredElements) {
        const takeElements =
          this.elementsByPage * this.page - this.filteredElements.length < 0
            ? this.elementsByPage * this.page
            : this.filteredElements.length
        return this.filteredElements.slice(
          this.elementsByPage * this.page - this.elementsByPage,
          takeElements
        )
      }
      return []
    },
    pages: function() {
      return this.filteredElements
        ? Math.ceil(this.filteredElements.length / this.elementsByPage)
        : 1
    },
    totalGroups: function() {
      return Math.ceil(this.pages / this.maxShowButtonPages)
    }
  },
  beforeMount() {
    this.getUsers()
    this.getMedicinesData()
    this.getHousesInformation()
    this.getSpecialists()
  },
  methods: {
    async getUsers() {
      this.$store.commit('main/setShowSpinner', true)
      const isAdmin =
        this.$store.state.auth.user.role.role.toUpperCase() === 'ADMIN'
      try {
        const response = isAdmin
          ? await this.axios.get('/residents', {
              headers: {
                Authorization: `Bearer ${this.$store.state.auth.token}`
              }
            })
          : await this.axios.get(
              `/client-by-id/${this.$store.state.auth.user.id}`,
              {
                headers: {
                  Authorization: `Bearer ${this.$store.state.auth.token}`
                }
              }
            )
        if (isAdmin) {
          if (Array.isArray(response.data) && response.data.length) {
            this.residents = response.data
            this.residentSelected = this.residents[0]
            this.residentInformation = await this.getMedicalResidentInformation()
            this.meds = await this.getMedsData()
            this.docuInfo = await this.getDocsInformation()
            this.NotasIDs = await this.notasID()
            this.medNotasIDs = await this.mednotasID()
          }
        } else {
          if (
            response.data &&
            Array.isArray(response.data.residents) &&
            response.data.residents.length
          ) {
            this.residents = response.data.residents
            this.residentSelected = this.residents[0]
            this.residentInformation = await this.getMedicalResidentInformation()
            this.meds = await this.getMedsData()
            this.docuInfo = await this.getDocsInformation()
            this.NotasIDs = await this.notasID()
            this.medNotasIDs = await this.mednotasID()
          }
        }
      } catch (error) {
        if (error.response) {
          console.error(error.response)
          this.$toast.error(error.response.data.message, {
            position: 'top'
          })
        }
      } finally {
        this.$store.commit('main/setShowSpinner', false)
      }
    },
    async getUsersRefresh(userNum) {
      this.$store.commit('main/setShowSpinner', true)
      const isAdmin =
        this.$store.state.auth.user.role.role.toUpperCase() === 'ADMIN'
      try {
        const response = isAdmin
          ? await this.axios.get('/residents', {
              headers: {
                Authorization: `Bearer ${this.$store.state.auth.token}`
              }
            })
          : await this.axios.get(
              `/client-by-id/${this.$store.state.auth.user.id}`,
              {
                headers: {
                  Authorization: `Bearer ${this.$store.state.auth.token}`
                }
              }
            )
        if (isAdmin) {
          if (Array.isArray(response.data) && response.data.length) {
            this.residents = response.data
            for (let i = 0; i < this.residents.length; i++) {
              if (this.residents[i].id == userNum) {
                this.residentSelected = this.residents[i]
              }
            }
            this.residentInformation = await this.getMedicalResidentInformation()
            this.meds = await this.getMedsData()
            this.docuInfo = await this.getDocsInformation()
            this.NotasIDs = await this.notasID()
            this.medNotasIDs = await this.mednotasID()
          }
        } else {
          if (
            response.data &&
            Array.isArray(response.data.residents) &&
            response.data.residents.length
          ) {
            this.residents = response.data.residents
            for (let i = 0; i < this.residents.length; i++) {
              if (this.residents[i].id == userNum) {
                this.residentSelected = this.residents[i]
              }
            }
            this.residentInformation = await this.getMedicalResidentInformation()
            this.meds = await this.getMedsData()
            this.docuInfo = await this.getDocsInformation()
            this.NotasIDs = await this.notasID()
            this.medNotasIDs = await this.mednotasID()
          }
        }
      } catch (error) {
        if (error.response) {
          console.error(error.response)
          this.$toast.error(error.response.data.message, {
            position: 'top'
          })
        }
      } finally {
        this.$store.commit('main/setShowSpinner', false)
      }
    },
    async changeResidentSelected() {
      this.$store.commit('main/setShowSpinner', true)
      this.docsData = []
      this.medNotasIDs = []
      this.NotasIDs = []
      this.residentInformation = await this.getMedicalResidentInformation()
      this.meds = await this.getMedsData()
      this.docuInfo = await this.getDocsInformation()
      this.NotasIDs = await this.notasID()
      this.medNotasIDs = await this.mednotasID()
      this.$store.commit('main/setShowSpinner', false)
    },
    notasID() {
      if (this.residentInformation) {
        const tableheaders = []
        for (let i = 0; i < this.residentInformation.length; i++) {
          const test = this.residentInformation[i].notas
          if (test != null) {
            tableheaders.push(this.residentInformation[i])
          }
          if (tableheaders.length > 10) {
            return tableheaders.reverse()
          }
        }
        return tableheaders.reverse()
      }
      return []
    },
    mednotasID() {
      if (this.residentInformation) {
        const tableheaders = []
        for (let i = 0; i < this.residentInformation.length; i++) {
          const test = this.residentInformation[i].med_notas
          if (test != null) {
            tableheaders.push(this.residentInformation[i])
          }
          if (tableheaders.length > 10) {
            return tableheaders.reverse()
          }
        }
        return tableheaders.reverse()
      }
      return []
    },
    setVisualize(row) {
      this.rowSelectedTwo = row
      const modal = this.$refs.visualizeRow
      cash(modal).modal('show')
    },
    setEditResident() {
      this.rowSelected = this.residentSelected
      this.editForm = {
        fullName: this.residentSelected.full_name,
        dateEntry: this.residentSelected.date_entry,
        birthDate: this.residentSelected.birth_date,
        specialistId: this.residentSelected.specialist_id || '',
        houseId: this.residentSelected.house_id
      }
      this.v$.$reset()
      const modal = this.$refs.editRow
      cash(modal).modal('show')
      setTimeout(() => {
        cash('.modal.overflow-y-auto.show').css('z-index', '9998')
      }, 1000)
    },
    async getDocsInformation() {
      this.$store.commit('main/setShowSpinner', true)
      try {
        const response = await this.axios.get(
          `/documents-by-resident/${this.residentSelected.id}`,
          {
            headers: {
              Authorization: `Bearer ${this.$store.state.auth.token}`
            }
          }
        )
        this.docsData = response.data || []
      } catch (error) {
        if (error?.response?.status === 401) {
          this.$toast.error('Su sesión ha expirado', {
            position: 'top'
          })
          return cleanSession(this.$store, this.$router)
        }
        this.$toast.error(getFirstErrorMessage(error), {
          position: 'top'
        })
      } finally {
        this.$store.commit('main/setShowSpinner', false)
        window.scrollTo(0, 0)
      }
    },
    async getHousesInformation() {
      try {
        const response = await this.axios.get('/houses', {
          headers: {
            Authorization: `Bearer ${this.$store.state.auth.token}`
          }
        })
        this.houses = response.data || []
      } catch (error) {
        if (error?.response?.status === 401) {
          this.$toast.error('Su sesión ha expirado', {
            position: 'top'
          })
          return cleanSession(this.$store, this.$router)
        }
        this.$toast.error(getFirstErrorMessage(error), {
          position: 'top'
        })
      }
    },
    async getSpecialists() {
      try {
        const response = await this.axios.get('/specialists', {
          headers: {
            Authorization: `Bearer ${this.$store.state.auth.token}`
          }
        })
        this.specialists = response.data || []
      } catch (error) {
        if (error?.response?.status === 401) {
          this.$toast.error('Su sesión ha expirado', {
            position: 'top'
          })
          return cleanSession(this.$store, this.$router)
        }
        this.$toast.error(getFirstErrorMessage(error), {
          position: 'top'
        })
      }
    },
    async editAction() {
      this.$store.commit('main/setShowSpinner', true)
      try {
        const body = {
          full_name: this.editForm.fullName,
          date_entry: this.editForm.dateEntry,
          birth_date: this.editForm.birthDate,
          house_id: this.editForm.houseId,
          specialist_id: this.editForm.specialistId || null
        }
        await this.axios.put(`/update-resident/${this.rowSelected.id}`, body, {
          headers: {
            Authorization: `Bearer ${this.$store.state.auth.token}`
          }
        })
        const userNum = this.residentSelected.id
        await this.getUsersRefresh(userNum)
        const modal = this.$refs.editRow
        cash(modal).modal('hide')
        this.$toast.success('El registro se ha modificado con exito', {
          position: 'top'
        })
      } catch (error) {
        if (error?.response?.status === 401) {
          this.$toast.error('Su sesión ha expirado', {
            position: 'top'
          })
          return cleanSession(this.$store, this.$router)
        }
        this.$toast.error(getFirstErrorMessage(error), {
          position: 'top'
        })
      } finally {
        this.$store.commit('main/setShowSpinner', false)
        window.scrollTo(0, 0)
      }
    },
    async getMedicalResidentInformation() {
      try {
        const response = await this.axios.get(
          `/medical-resident-information/${this.residentSelected.id}`,
          {
            headers: {
              Authorization: `Bearer ${this.$store.state.auth.token}`
            }
          }
        )
        if (Array.isArray(response.data) && response.data.length) {
          return response.data
        }
      } catch (error) {
        this.$toast.error('Ocurrió un problema al obtener las gráficas', {
          position: 'top'
        })
      }
    },
    async onFileSelected(event) {
      this.selectedFile = event.target.files[0]
      this.onUpload()
    },
    async dateFilter(event) {
      this.dateForm = {
        dateTwo: this.dateForm.daterange.slice(13),
        dateOne: this.dateForm.daterange.slice(0, 10)
      }
    },
    setViewKardex() {
      this.kardex = !this.kardex
      this.isHidden = this.kardex
    },
    async deleteItemKardex(kardexId) {
      this.$store.commit('main/setShowSpinner', true)
      try {
        await this.axios.delete(`/delete-kardex/${kardexId}`, {
          headers: {
            Authorization: `Bearer ${this.$store.state.auth.token}`
          }
        })
        const userNum = this.residentSelected.id
        await this.getUsersRefresh(userNum)
        this.kardex = !this.kardex
        this.isHidden = this.kardex
        this.$toast.success(
          'El registro ha sido eliminado satisfactoriamente',
          {
            position: 'top'
          }
        )
      } catch (error) {
        if (error?.response?.status === 401) {
          this.$toast.error('Su sesión ha expirado', {
            position: 'top'
          })
          return cleanSession(this.$store, this.$router)
        }
        this.$toast.error(getFirstErrorMessage(error), {
          position: 'top'
        })
      } finally {
        this.$store.commit('main/setShowSpinner', false)
        window.scrollTo(0, 0)
      }
    },
    async getMedicinesData() {
      try {
        const response = await this.axios.get('/medicines', {
          headers: {
            Authorization: `Bearer ${this.$store.state.auth.token}`
          }
        })
        this.medicines = response.data || []
      } catch (error) {
        if (error?.response?.status === 401) {
          this.$toast.error('Su sesión ha expirado', {
            position: 'top'
          })
          return cleanSession(this.$store, this.$router)
        }
        this.$toast.error(getFirstErrorMessage(error), {
          position: 'top'
        })
      }
    },
    async getMedsData() {
      try {
        const response = await this.axios.get(
          `/meds-by-resident/${this.residentSelected.id}`,
          {
            headers: {
              Authorization: `Bearer ${this.$store.state.auth.token}`
            }
          }
        )
        if (Array.isArray(response.data) && response.data.length) {
          return response.data
        }
      } catch (error) {
        this.$toast.error('Ocurrió un problema al obtener las gráficas', {
          position: 'top'
        })
      }
    },
    changePagePositiveTwo() {
      const page = this.pageTwo + 1
      if (page > this.activeGroupTwo * this.maxShowButtonPagesTwo) {
        this.activeGroupTwo++
      }
      this.pageTwo++
    },
    changePageNegativeTwo() {
      const page = this.pageTwo - 1
      if (page <= (this.activeGroupTwo - 1) * this.maxShowButtonPagesTwo) {
        this.activeGroupTwo =
          this.activeGroupTwo - 1 === 0 ? 1 : this.activeGroupTwo - 1
      }
      this.pageTwo--
    },
    setFirstPageTwo() {
      this.pageTwo = 1
      this.activeGroupTwo = 1
    },
    setlastPageTwo() {
      this.pageTwo = this.pagesTwo
      this.activeGroupTwo = this.totalGroupsTwo
    },
    changePagePositiveFour() {
      const page = this.pageFour + 1
      if (page > this.activeGroupFour * this.maxShowButtonPagesFour) {
        this.activeGroupFour++
      }
      this.pageFour++
    },
    changePageNegativeFour() {
      const page = this.pageFour - 1
      if (page <= (this.activeGroupFour - 1) * this.maxShowButtonPagesFour) {
        this.activeGroupFour =
          this.activeGroupFour - 1 === 0 ? 1 : this.activeGroupFour - 1
      }
      this.pageFour--
    },
    setFirstPageFour() {
      this.pageFour = 1
      this.activeGroupFour = 1
    },
    setlastPageFour() {
      this.pageFour = this.pagesFour
      this.activeGroupFour = this.totalGroupsFour
    },
    setFirstPageMeds() {
      this.pageMeds = 1
      this.activeGroupMeds = 1
    },
    setlastPageMeds() {
      this.pageMeds = this.pagesMeds
      this.activeGroupMeds = this.totalGroupsMeds
    },
    changePagePositiveMeds() {
      const pageMeds = this.pageMeds + 1
      if (pageMeds > this.activeGroupMeds * this.maxShowButtonPagesMeds) {
        this.activeGroupMeds++
      }
      this.pageMeds++
    },
    changePageNegativeMeds() {
      const pageMeds = this.pageMeds - 1
      if (
        pageMeds <=
        (this.activeGroupMeds - 1) * this.maxShowButtonPagesMeds
      ) {
        this.activeGroupMeds =
          this.activeGroupMeds - 1 === 0 ? 1 : this.activeGroupMeds - 1
      }
      this.pageMeds--
    },
    changePagePositive() {
      const page = this.page + 1
      if (page > this.activeGroup * this.maxShowButtonPages) {
        this.activeGroup++
      }
      this.page++
    },
    changePageNegative() {
      const page = this.page - 1
      if (page <= (this.activeGroup - 1) * this.maxShowButtonPages) {
        this.activeGroup = this.activeGroup - 1 === 0 ? 1 : this.activeGroup - 1
      }
      this.page--
    },
    setFirstPage() {
      this.page = 1
      this.activeGroup = 1
    },
    setlastPage() {
      this.page = this.pages
      this.activeGroup = this.totalGroups
    },
    showModalCreateMeds() {
      this.createFormMeds = {
        resident_id: this.residentSelected.id,
        med_name: '',
        dose: '',
        presentation: '',
        observaciones: '',
        horario: '',
        prescribed_date: ''
      }
      this.v$.$reset()
      const modal = this.$refs.createRowMeds
      cash(modal).modal('show')
      setTimeout(() => {
        cash('.modal.overflow-y-auto.show').css('z-index', '9998')
      }, 1000)
    },
    async createActionMeds() {
      this.$store.commit('main/setShowSpinner', true)
      try {
        await this.axios.post(
          '/create-med',
          {
            ...this.createFormMeds
          },
          {
            headers: {
              Authorization: `Bearer ${this.$store.state.auth.token}`
            }
          }
        )
        const modal = this.$refs.createRowMeds
        cash(modal).modal('hide')
        const userNum = this.residentSelected.id
        await this.getUsersRefresh(userNum)
        this.$toast.success('El registro se ha creado con exito', {
          position: 'top'
        })
      } catch (error) {
        if (error?.response?.status === 401) {
          this.$toast.error('Su sesión ha expirado', {
            position: 'top'
          })
          return cleanSession(this.$store, this.$router)
        }
        this.$toast.error(getFirstErrorMessage(error), {
          position: 'top'
        })
      } finally {
        this.$store.commit('main/setShowSpinner', false)
        window.scrollTo(0, 0)
      }
    },
    setToDelete(row) {
      this.rowSelected = row
      const modal = this.$refs.deleteRow
      cash(modal).modal('show')
    },
    async deleteAction() {
      const modal = this.$refs.deleteRow
      cash(modal).modal('hide')
      this.$store.commit('main/setShowSpinner', true)
      try {
        await this.axios.delete(`/delete-med/${this.rowSelected.id}`, {
          headers: {
            Authorization: `Bearer ${this.$store.state.auth.token}`
          }
        })
        const userNum = this.residentSelected.id
        await this.getUsersRefresh(userNum)
        this.$toast.success(
          'El registro ha sido eliminado satisfactoriamente',
          {
            position: 'top'
          }
        )
      } catch (error) {
        if (error?.response?.status === 401) {
          this.$toast.error('Su sesión ha expirado', {
            position: 'top'
          })
          return cleanSession(this.$store, this.$router)
        }
        this.$toast.error(getFirstErrorMessage(error), {
          position: 'top'
        })
      } finally {
        this.$store.commit('main/setShowSpinner', false)
        window.scrollTo(0, 0)
      }
    },
    setToEdit(row) {
      this.rowSelected = row
      this.editFormMeds = {
        resident_id: this.residentSelected.id,
        med_name: this.rowSelected.med_name || '',
        dose: this.rowSelected.dose || '',
        presentation: this.rowSelected.presentation || '',
        observaciones: this.rowSelected.observaciones || '',
        horario: this.rowSelected.horario || '',
        prescribed_date: this.rowSelected.prescribed_date || ''
      }
      this.v$.$reset()
      const modal = this.$refs.editRowMeds
      cash(modal).modal('show')
      setTimeout(() => {
        cash('.modal.overflow-y-auto.show').css('z-index', '9998')
      }, 1000)
    },
    async editActionMeds() {
      this.$store.commit('main/setShowSpinner', true)
      try {
        const body = {
          resident_id: this.residentSelected.id,
          med_name: this.editFormMeds.med_name || null,
          dose: this.editFormMeds.dose || null,
          presentation: this.editFormMeds.presentation || null,
          observaciones: this.editFormMeds.observaciones || null,
          horario: this.editFormMeds.horario || null,
          prescribed_date: this.editFormMeds.prescribed_date || null
        }
        await this.axios.put(`/update-med/${this.rowSelected.id}`, body, {
          headers: {
            Authorization: `Bearer ${this.$store.state.auth.token}`
          }
        })
        const modal = this.$refs.editRowMeds
        cash(modal).modal('hide')
        const userNum = this.residentSelected.id
        await this.getUsersRefresh(userNum)
        this.$toast.success('El registro se ha modificado con exito', {
          position: 'top'
        })
      } catch (error) {
        if (error?.response?.status === 401) {
          this.$toast.error('Su sesión ha expirado', {
            position: 'top'
          })
          return cleanSession(this.$store, this.$router)
        }
        this.$toast.error(getFirstErrorMessage(error), {
          position: 'top'
        })
      } finally {
        this.$store.commit('main/setShowSpinner', false)
        window.scrollTo(0, 0)
      }
    },
    showModalCreate(row) {
      this.createForm = {
        resident_id: this.residentSelected.id,
        medicine_id: row.id,
        type: undefined,
        dose: undefined
      }
      const modal = this.$refs.createRow
      cash(modal).modal('show')
    },
    changeKardexType() {
      this.createForm = {
        resident_id: this.createForm.resident_id,
        medicine_id: this.createForm.medicine_id,
        type: this.createForm.type,
        dose: this.createForm.dose
      }
    },
    async createAction() {
      this.$store.commit('main/setShowSpinner', true)
      const modal = this.$refs.createRow
      cash(modal).modal('hide')
      this.kardex = false
      this.isHidden = this.kardex

      try {
        await this.axios.post(
          '/create-kardex',
          {
            ...this.createForm
          },
          {
            headers: {
              Authorization: `Bearer ${this.$store.state.auth.token}`
            }
          }
        )
        const userNum = this.residentSelected.id
        await this.getUsersRefresh(userNum)
        this.$toast.success('El registro se ha modificado con exito', {
          position: 'top'
        })
      } catch (error) {
        if (error?.response?.status === 401) {
          this.$toast.error('Su sesión ha expirado', {
            position: 'top'
          })
          return cleanSession(this.$store, this.$router)
        }
        this.$toast.error(getFirstErrorMessage(error), {
          position: 'top'
        })
      } finally {
        this.$store.commit('main/setShowSpinner', false)
        window.scrollTo(0, 0)
      }
    },
    setViewModalMedical() {
      this.medicalForm = this.residentSelected.medical
        ? { ...this.residentSelected.medical }
        : { resident_id: this.residentSelected.id }
      const modal = this.$refs.rowMedical
      cash(modal).modal('show')
    },
    async editMedicalAction() {
      this.$store.commit('main/setShowSpinner', true)
      const modal = this.$refs.rowMedical
      cash(modal).modal('hide')
      try {
        if (this.medicalForm.id) {
          await this.axios.put(
            `/update-medical-record/${this.medicalForm.id}`,
            this.medicalForm,
            {
              headers: {
                Authorization: `Bearer ${this.$store.state.auth.token}`
              }
            }
          )
        } else {
          await this.axios.post('/create-medical-record', this.medicalForm, {
            headers: {
              Authorization: `Bearer ${this.$store.state.auth.token}`
            }
          })
        }
        const userNum = this.residentSelected.id
        await this.getUsersRefresh(userNum)
        this.$toast.success('El registro se ha modificado con exito', {
          position: 'top'
        })
      } catch (error) {
        if (error?.response?.status === 401) {
          this.$toast.error('Su sesión ha expirado', {
            position: 'top'
          })
          return cleanSession(this.$store, this.$router)
        }
        this.$toast.error(getFirstErrorMessage(error), {
          position: 'top'
        })
      } finally {
        this.$store.commit('main/setShowSpinner', false)
        window.scrollTo(0, 0)
      }
    },
    async onUpload() {
      const form = new FormData()
      form.append('image', this.selectedFile)
      await this.axios({
        method: 'post',
        url: `/edit-image-resident/${this.residentSelected.id}`,
        data: form,
        headers: { Authorization: `Bearer ${this.$store.state.auth.token}` }
      }).then(res => {})
    },
    indexOfMax(arr) {
      if (arr.length === 0) {
        return -1
      }
      let max = arr[0]
      let maxIndex = 0
      for (let i = 1; i < arr.length; i++) {
        if (arr[i] > max) {
          maxIndex = i
          max = arr[i]
        }
      }
      return maxIndex
    }
  }
}
</script>
